export var ThemesColorsEnum;
(function (ThemesColorsEnum) {
    ThemesColorsEnum["THEME_DEFAULT"] = "default";
    ThemesColorsEnum[ThemesColorsEnum["THEME_02"] = 2] = "THEME_02";
    ThemesColorsEnum[ThemesColorsEnum["THEME_03"] = 3] = "THEME_03";
    ThemesColorsEnum["BLUE"] = "blue";
    ThemesColorsEnum["GREEN"] = "green";
    ThemesColorsEnum["SEM_CHAMADA"] = "csch";
})(ThemesColorsEnum || (ThemesColorsEnum = {}));
